import { IRolesAndSkills } from '../../models'
import { API } from '../API'
import { responseHandler } from '../responseHandlers'

export const getRoles = async (): Promise<IRolesAndSkills> => {
  return responseHandler(API.get('api/users/roles/'))
}
